module.exports = __webpack_public_path__ + "img/industry1_m.556ebbbc.jpg";